<template>
    <div>
        <div class="fadein">
            <div class="row">
                <div class="col_2">
                    <div class="form-group ">
                        <label>{{ $t('common.grade') }}</label>
                        <div class="d_flex_start">
                            <div class="dropdown custom_dropdown mr_10">
                                <button class="btn">
                                    <span>{{ filter2.grade }}</span>
                                </button>
                                <div class="dropdown_menu">
                                    <ul>
                                        <li><a role="button" @click="changeGradeFilter('all')">{{ $t('common.all') }}</a></li>
                                        <li v-for="grade in grades" :key="'grade '+grade.id">
                                            <a role="button" @click="changeGradeFilter(grade)">{{ grade.name }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col_2">
                    <div class="form-group ">
                        <label>{{ $t('sidebar.semesters.semesters') }}</label>
                        <div class="d_flex_start">
                            <div class="dropdown custom_dropdown mr_10">
                                <button class="btn">
                                    <span>{{ filter2.semester }}</span>
                                </button>
                                <div class="dropdown_menu">
                                    <ul>
                                        <li><a role="button" @click="changeSemesterFilter('all')">{{ $t('common.all') }}</a></li>
                                        <li v-for="semester in semesters" :key="'semester '+semester.id">
                                            <a role="button" @click="changeSemesterFilter(semester)">{{ semester.name }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col_1">
                    <div class="form-group ">
                        <label>{{ $t('common.unit') }}</label>
                        <div class="d_flex_start">
                            <div class="dropdown custom_dropdown mr_10">
                                <button class="btn">
                                    <span>{{ filter2.unit }}</span>
                                </button>
                                <div class="dropdown_menu">
                                    <ul>
                                        <li><a role="button" @click="changeUnitFilter('all')">{{ $t('common.all') }}</a></li>
                                        <li v-for="unit in units" :key="'unit '+unit.id">
                                            <a role="button" @click="changeUnitFilter(unit)">{{ unit.unit_name }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col_1">
                    <div class="form-group ">
                        <label>{{ $t('common.chapter') }}</label>
                        <div class="d_flex_start">
                            <div class="dropdown custom_dropdown mr_10">
                                <button class="btn">
                                    <span>{{ filter2.chapter }}</span>
                                </button>
                                <div class="dropdown_menu">
                                    <ul>
                                        <li><a role="button" @click="changeChapterFilter('all')">{{ $t('common.all') }}</a></li>
                                        <li v-for="chapter in chapters" :key="'chapter '+chapter.id">
                                            <a role="button" @click="changeChapterFilter(chapter)">{{ chapter.name }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col_1">
                    <div class="form-group">
                    <label>{{ $t('common.parking') }}</label>
                    <div class="drop-down">
                        <div class="selected">
                            <span>{{ filter2.parking }}</span>
                        </div>
                        <div class="options">
                            <ul style="display: none;">
                                <li @click="changeParkingFilter(parking)" v-for="parking in parkings" :key="'parking'+parking.id">{{ parking.name }}<span class="value">{{ parking.id }}</span></li>
                            </ul>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="col_1">
                    <div class="form-group ">
                        <label>{{ $t('common.thinking_area') }}</label>
                        <div class="d_flex_start">
                            <div class="dropdown custom_dropdown mr_10">
                                <button class="btn">
                                    <span>{{ filter2.thinking_area }}</span>
                                </button>
                                <div class="dropdown_menu">
                                    <ul>
                                        <li><a role="button" @click="changeThinkingAreaFilter('all')">{{ $t('common.all') }}</a></li>
                                        <li v-for="thinking_area in thinking_areas" :key="'thinking_area '+thinking_area.id">
                                            <a role="button" @click="changeThinkingAreaFilter(thinking_area)">{{ thinking_area.name }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col_4">
                    <div class="form-group ">
                        <label></label>
                        <div class="d_flex_end">
                            <div class="form_row_inline">
                                <input type="text" class="form_global" :placeholder="$t('common.search')" v-model="queryParams.search">
                            </div>
                            <!-- <div class="form_row_inline">
                                <input type="text" class="form_global">
                            </div>
                            <div class="form_row_inline">
                                <label class="width_auto no_wrap pl_20 pr_20">{{ $t('from') }}</label>
                                <input type="text" class="form_global">
                            </div>
                            <div class="form_row_inline">
                                <label class="width_auto no_wrap pl_20 pr_20">{{ $t('to') }}</label>
                                <input type="text" class="form_global">
                            </div> -->
                            <div class="form_row_inline ml_10">
                                <div class="btn btn_common_type_2 width_150p" @click="searchQuery()">{{ $t('common.search') }}</div>
                                <div class="btn btn_common_type_2 width_150p ml_10" @click="resetAll()">{{ $t('common.reset') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col_12 ">
                    <div class="separator pl_0 pr_0">
                        <span></span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col_12">
                    <div class="d_flex_btwn pt_20 pb_20">
                        <div class="d_flex_start col_2 pl_0">
                            <div class="dropdown custom_dropdown mr_10">
                                <button class="btn">
                                    <span>{{ filter.per_page }}</span>
                                </button>
                                <div class="dropdown_menu">
                                    <ul>
                                        <li @click="changeFilter(10)"><a role="button">10</a></li>
                                        <li @click="changeFilter(20)"><a role="button">20</a></li>
                                        <li @click="changeFilter(50)"><a role="button">50</a></li>
                                        <li @click="changeFilter(100)"><a role="button">100</a></li>
                                        <li @click="changeFilter(200)"><a role="button">200</a></li>
                                    </ul>
                                </div>
                            </div>
                            <button class="btn btn_transparent ml_10 mr_10">{{ $t('common.download_contents') }}</button>
                            <button class="btn btn_transparent">{{ $t('common.upload_contents') }}</button>
                        </div>
                        <div class="d_flex_end col_6 pr_0">
                            <div class="form_checkbox">
                                <input type="checkbox" id="show" v-model="form.show" @change="updateLectureVisibility()">
                                <label for="show">{{ $t('common.active') }}</label>
                            </div>
                            <router-link :to="{ name: 'thinking_skill_thinking_ability_add'}" class="add_new cursor_pointer btn btn_transparent">+ {{ $t('sidebar.thinkingSkill.addNewThinkingAbility') }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <table-component :columns="columns" :rows="thinkingAbilities" :pagination="pagination" @sorting="sorting" :sortable="sortable" @pageChanged="pageChanged">
                <template #id="{ row }">
                    <div class="form_checkbox">
                        <input type="checkbox" :id="'course' + row.id" :checked="checkedLecture.includes(row.id)" name="checkbox">
                        <label :for="'course' + row.id" @click="checkedSingleLecture(row.id)"></label>
                    </div>
                </template>
                <!-- <template #convert_status="{ row }">
                    <div v-if="row.lectureVideos && row.lectureVideos.length">
                      <span class="convert_status" v-html="checkUploadStatus(row.lectureVideos)"> </span>
                    </div>
                </template> -->
              <template #order="{ row }">
                <div @keyup.enter="updateRecordOrder(row)">
                  <input type="text" min="0" :value="row.order"
                         class="form_global width_50p"
                         @input="onInputChangeOrder($event, row)"
                  >
                  <button class="btn btn_success" style="padding: 5px 10px;" @click="updateRecordOrder(row)">
                    <i class="fas fa-check"></i>
                  </button>
                </div>
              </template>
                <template #thinking_ability="{ row }">
                    <div class="">
                        <button class="btn btn_yellow ml_5 mr_5" @click.prevent="showAllVideo(row.lectureVideos)" v-if="row.lectureVideos && row.lectureVideos.length > 0">{{ $t('sidebar.lectureCommon.video') }}</button>
                        <template v-for="(exam, index) in row.thinkingAbility" :key="'thinking_ability' + index">
                            <button class="btn btn_yellow ml_5 mr_5" @click.prevent="showQuestion(exam)">{{ $t('sidebar.lectureCommon.exam') }}</button>
                        </template>
                        <!-- <button class="btn btn_yellow ml_5 mr_5" @click.prevent="showAllVideo(row.explanationVideos)" v-if="row.explanationVideos.length">{{ $t('sidebar.lectureCommon.explanation_video') }}</button> -->
                    </div>
                </template>
                <template #action="{ row }">
                    <div class="d_flex_center table_action_btn">
                        <button v-if="row.status == 1" class="btn btn_success status_update" title="Active" @click.prevent="deactivate(row)">
                            <i class="fas fa-check"></i>
                        </button>
                        <button v-else class="btn btn_warning status_update" title="Inactive" @click.prevent="activate(row)">
                            <i class="fa fa-window-close"></i>
                        </button>
                        <router-link :to="{name: 'thinking_skill_thinking_ability_edit', params:{id: row.id}}" :title="$t('common.edit')" class="btn btn_blue ml_10">
                            <img :src="`${baseUrl}assets/media/images/icon/8.png`" alt="">
                        </router-link>
                        <button class="btn btn_danger ml_10" :title="$t('common.delete')" @click.prevent="deleteRecord(row)">
                            <img :src="`${baseUrl}assets/media/images/icon/9.png`" alt="">
                        </button>
                    </div>
                </template>
            </table-component>
        </div>
        <video-modal v-if="videoModalShow" :showVideoModal="videoModalShow" :video="videoSmilFile" @closeModal="closeModal()"></video-modal>
        <all-video-modal v-if="allVideoModalShow" :allVideoModalShow="allVideoModalShow" :videos="lectureAllVideos" @closeModal="closeModal()"></all-video-modal>
        <question-modal 
          v-if="questionModalShow" 
          :showQuestionModal="questionModalShow" 
          :questionExam="questionExam" 
          @closeModal="closeModal()" 
        />
    </div>
    </template>
    
    <script>
    import TableComponent from "@/components/shared/TableComponent";
    import VideoModal from "../../components/VideoModal.vue";
    import AllVideoModal from "../../components/AllVideoModal.vue";
    import QuestionModal from "@/components/QuestionModal.vue";
    export default {
        name: 'thinking-ability',
        components: {
            TableComponent,
            VideoModal,
            QuestionModal,
            AllVideoModal,
        },
        data() {
            return {
                baseUrl: process.env.VUE_APP_BASE,
                thinkingAbilities: [],
                grades: [],
                semesters: [],
                units: [],
                chapters: [],
                parkings: [],
                thinking_areas: [],
                checkedLecture: [],
                filter: {
                    grade: '',
                    semester: '',
                    unit: '',
                    chapter: '',
                    parking: '',
                    thinking_area: '',
                    per_page: 20
                },
                filter2: {
                    grade: this.$t('common.all'),
                    semester: this.$t('common.all'),
                    unit: this.$t('common.all'),
                    chapter: this.$t('common.all'),
                    parking: this.$t('common.all'),
                    thinking_area: this.$t('common.all'),
                    per_page: 20
                },
                queryParams: {
                    page: 1,
                    search: '',
                    search_columns: 'video_name',
                    sort: 'created_at',
                    sort_order: 'desc',
                    per_page: 20
                },
                pagination: null,
                sortable: {
                    order: 'created_at',
                    sort: 'desc'
                },
    
                columns: [
                    {
                        label: '',
                        field: "id",
                        sortable: false,
                        slot: true
                    },
                    {
                        label: this.$t('common.subject'),
                        field: "subject.name",
                        sortable: false
                    },
                    {
                        label: this.$t('common.grade'),
                        field: "grade.name",
                        sortable: false
                    },
                    {
                        label: this.$t('common.semester'),
                        field: "semester.name",
                        sortable: false
                    },
                    {
                      label: this.$t('common.order'),
                      field: "order",
                      sortable: false,
                      slot: true,
                    },
                    {
                        label: this.$t('common.unit'),
                        field: "unit.unit_name",
                        sortable: false
                    },
                    {
                        label: this.$t('common.chapter'),
                        field: "chapter.name",
                        sortable: false
                    },
                    {
                        label: this.$t('common.thinking_area'),
                        field: "thinking_area.name",
                        sortable: false
                    },
                    {
                        label: this.$t('common.created_at'),
                        field: "created_at",
                        sortable: false
                    },
                    {
                        label: this.$t('sidebar.lectureCommon.convert_status'),
                        field: "video_convert_status",
                        sortable: false
                    },
                    {
                        label: this.$t('sidebar.thinkingSkill.thinkingAbility'),
                        field: "thinking_ability",
                        sortable: false,
                        slot: true
                    },
                    {
                        label: this.$t('common.action'),
                        field: 'action',
                        sortable: false,
                        slot: true,
                    }
                ],
                videoSmilFile: null,
                videoModalShow: false,
                allVideoModalShow: false,
                lectureAllVideos: [],
                questionModalShow: false,
                questionExam: null,
                form: {
                    show: true,
                    lecture_type: 'thinking-skill',
                    lecture_sub_type: 'thinking-ability',
                }
            }
        },
        watch: {
            $route(to, from) {
                if (to.name == from.name && !window._.isEqual(to, from)) {
                    this.setQueryData(this.getAllQueryParams())
                    this.loadData()
                }
            },
        },
        created() {
            const query = this.getAllQueryParams()
            if (query.page) {
                this.setQueryData(query)
            }
    
            this.axios.get('/grades').then((response) => this.grades = response.data.data);
            this.axios.get('/semesters').then((response) => this.semesters = response.data.data);
            this.axios.get('/parkings').then((response) => this.parkings = response.data.data);
            this.axios.get('/thinking-areas').then((response) => this.thinking_areas = response.data.data);
            this.axios.post('/get-lecture-visibility',this.form).then((response) => {
                this.form.show = response.data.data.show == 1 ? true : false    
            });
    
            this.loadData();
        },
        methods: {
            setQueryData(query) {
                this.queryParams = {
                    page: query.page,
                    search: query.search,
                    search_columns: query.search_columns,
                    sort: query.sort,
                    sort_order: query.sort_order,
                    per_page: query.per_page
                }
    
                this.filter = {
                    grade: query.grade,
                    semester: query.semester,
                    unit: query.unit,
                    chapter: query.chapter,
                    parking: query.parking,
                    thinking_area: query.thinking_area,
                    per_page: query.per_page
                }
    
                this.sortable = {
                    order: query.sort,
                    sort: query.sort_order
                }
            },
            resetAll() {
                this.sortable = {
                    order: 'created_at',
                    sort: 'desc'
                }
    
                this.filter = {
                    grade: '',
                    semester: '',
                    unit: '',
                    chapter: '',
                    parking: '',
                    thinking_area: '',
                    per_page: 20
                }
                
                this.filter2 = {
                    grade: this.$t('common.all'),
                    semester: this.$t('common.all'),
                    unit: this.$t('common.all'),
                    chapter: this.$t('common.all'),
                    parking: this.$t('common.all'),
                    thinking_area: this.$t('common.all'),
                }
    
                this.queryParams = {
                    page: 1,
                    search: '',
                    search_columns: 'video_name',
                    sort: 'created_at',
                    sort_order: 'desc',
                    per_page: 20
                }
                this.units = []
                this.chapters = []
    
                this.changeRoute();
                this.loadData();
            },
            searchQuery() {
                this.changeRoute();
            },
            sorting({
                column,
                order
            }) {
                this.queryParams.sort = column;
                this.queryParams.sort_order = order;
                this.queryParams.page = 1;
                this.changeRoute()
            },
            pageChanged(page) {
                this.queryParams.page = page;
                this.changeRoute()
            },
            changeGradeFilter(grade) {
                if (grade == 'all') {
                    this.filter.grade = ''
                    this.filter2.grade = this.$t('common.all')
                } else {
                    this.filter.grade = grade.id
                    this.filter2.grade = grade.name
                }
                this.changeData();
                this.changeRoute();
            },
            changeSemesterFilter(semester) {
                if (semester == 'all') {
                    this.filter.semester = ''
                    this.filter2.semester = this.$t('common.all')
                } else {
                    this.filter.semester = semester.id
                    this.filter2.semester = semester.name
                }
                this.changeData();
                this.changeRoute();
            },
            changeData(){
                let grade_id = this.filter.grade
    
                if(grade_id == ''){
                    this.units = []
                    this.chapters = []
                }
    
                let semester_id = this.filter.semester
    
                if(semester_id == ''){
                    this.units = []
                    this.chapters = []
                }
    
                if(grade_id && semester_id){
                    this.units = []
                    this.chapters = []
                    this.axios.post('/load-unit-data/', {'grade_id': grade_id, 'semester_id': semester_id})
                        .then((response) => {
                            let unitData = response.data.data
                            this.units = unitData
                            if(unitData && unitData.length < 1){
                                this.units = []
                            }
                        })
    
                    this.axios.post('/load-chapter-data/', {'grade_id': grade_id, 'semester_id': semester_id})
                        .then((response) => {
                            let chapterData = response.data.data
                            this.chapters = chapterData
                            if(chapterData && chapterData.length < 1){
                                this.chapters = []
                            }
                        })
                }
            },
            changeUnitFilter(unit) {
                if (unit == 'all') {
                    this.filter.unit = ''
                    this.filter2.unit = this.$t('common.all')
                } else {
                    this.filter.unit = unit.id
                    this.filter2.unit = unit.unit_name
                }
    
                this.changeRoute();
            },
            changeChapterFilter(chapter) {
                if (chapter == 'all') {
                    this.filter.chapter = ''
                    this.filter2.chapter = this.$t('common.all')
                } else {
                    this.filter.chapter = chapter.id
                    this.filter2.chapter = chapter.name
                }
    
                this.changeRoute();
            },
            changeParkingFilter(parking) {
                if (parking == 'all') {
                    this.filter.parking = ''
                    this.filter2.parking = this.$t('common.all')
                } else {
                    this.filter.parking = parking.id
                    this.filter2.parking = parking.name
                }
    
                this.changeRoute();
            },
            changeThinkingAreaFilter(thinking_area) {
                if (thinking_area == 'all') {
                    this.filter.thinking_area = ''
                    this.filter2.thinking_area = this.$t('common.all')
                } else {
                    this.filter.thinking_area = thinking_area.id
                    this.filter2.thinking_area = thinking_area.name
                }
    
                this.changeRoute();
            },
            changeFilter(per_page) {
                this.filter.per_page = per_page
                this.changeRoute();
            },
            changeRoute() {
                this.$router.push({
                    name: this.$route.name,
                    query: {
                        ...this.queryParams,
                        ...this.filter
                    }
                })
            },
            loadData() {
                this.axios.get('/thinking-abilities', {
                    params: {
                        ...this.queryParams,
                        ...this.filter
                    }
                }).then((response) => {
                    this.thinkingAbilities = response.data.data;
                    this.pagination = response.data.meta;
                })
            },
            checkedSingleLecture(id) {
                let index = window._.findIndex(this.checkedLecture, (checkedLectureId) => checkedLectureId == id)
                if (index > -1)
                    this.checkedLecture.splice(index, 1)
                else
                    this.checkedLecture.push(id)
            },
            showVideo(smilFile) {
                this.videoModalShow = true
                this.videoSmilFile = smilFile
            },
            showAllVideo(videos){
                this.allVideoModalShow = true
                this.lectureAllVideos = videos
            },
            showExplanationVideo(smilFile) {
                this.videoModalShow = true
                this.videoSmilFile = smilFile
            },
            showQuestion(exam) {
                this.questionExam = exam
                this.questionModalShow = true
            },
            closeModal() {
                this.questionExam = null
                this.videoModalShow = false
                this.questionModalShow = false
                this.allVideoModalShow = false
            },
            activate(lecture){
                let lecture_id = lecture.id;
                let status = lecture.status;
                this.$swal({
                    title: this.$t('common.active_confirmation'),
                    text: this.$t('common.warning'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: this.$t('common.yes_activate'),
                    cancelButtonText: this.$t('common.no_cancel'),
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.axios.post('/update-thinking-skill-status/', {'id': lecture_id, 'status': status}).then(() => {
                            this.loadData()
                            this.$swal.fire(
                                this.$t('common.activated'),
                                this.$t('common.activated_success'),
                                'success'
                            )
                        });
                    }
                });
            },
            deactivate(lecture){
                let lecture_id = lecture.id;
                let status = lecture.status;
                this.$swal({
                    title: this.$t('common.deactivate_confirmation'),
                    text: this.$t('common.warning'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: this.$t('common.yes_deactivate'),
                    cancelButtonText: this.$t('common.no_cancel'),
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.axios.post('/update-thinking-skill-status/', {'id': lecture_id, 'status': status}).then(() => {
                            this.loadData()
                            this.$swal.fire(
                                this.$t('common.deactivated'),
                                this.$t('common.deactivated_success'),
                                'success'
                            )
                        });
                    }
                });
            },
            deleteRecord(row) {
                this.$swal({
                    title: this.$t('common.deleteConfirmation'),
                    text: this.$t('common.warning'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: this.$t('common.yesDelete'),
                    cancelButtonText: this.$t('common.noCancel'),
                    confirmButtonColor: '#dd4b39',
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.axios.delete('/thinking-abilities/' + row.id).then(() => {
                            this.loadData();
                            this.$swal.fire(
                                this.$t('common.deleted'),
                                this.$t('common.deleteMessage'),
                                'success'
                            )
                        });
                    }
                });
            },
            // checkUploadStatus(videos){
            //     let status = '';
            //     videos.forEach(element => {
            //         if(videos.length == 1){
            //             status = element.convert_status
            //         }else{
            //             status = status +'</br>'+ element.convert_status
            //         }
            //     });
            //     return status
            // },
            updateLectureVisibility(){
                this.axios.post('/update-lecture-visibility', this.form).then(() => {
                    this.showSuccessMsg('성공적으로 업데이트되었습니다!')
                });
            },
          onInputChangeOrder(event, row) {
            const value = parseInt(event.target.value);
            row.order = isNaN(value) || value < 0 ? 0 : value;
          },
          updateRecordOrder(row){
            this.axios.post(`/update-thinking-abilities-order/${row.id}`, {
              order: row.order
            }).then(({ data }) => {
              if (data.success) {
                this.showSuccessMsg(data.message)
              } else {
                this.showFailMsg(data.message)
              }
            }).catch(({response}) => {
              if (response?.data?.message) {
                this.showFailMsg(response.data.message)
              }
            })
          }
        }
    }
    </script>
    <style scoped>
      .convert_status{
        white-space: pre-line !important;
      }
    </style>
    